module.exports = __webpack_public_path__ + "static/media/tech.32c43036.jpg";